import React from 'react'

export const MenuMainContext = React.createContext({
  menuNode: {},
  switchLocale: null,
  isSalesBanner: false,
})
export const MenuMainProvider = MenuMainContext.Provider
export const MenuMainConsumer = MenuMainContext.Consumer
